import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { CreateTwilioAccountParams, useTwilioAccountsService } from './twilio-accounts.service';
import { TwilioAccountModel } from './types';

const twilioAccountsListQueryKey = 'twilio-accounts-list';

export const useTwilioAccountsList = () => {
  const twilioAccountsService = useTwilioAccountsService();

  return useQuery({
    queryKey: [twilioAccountsListQueryKey],
    queryFn: () => twilioAccountsService.getTwilioAccounts(),
  });
};

export const useCreateTwilioAccount = () => {
  const twilioAccountsService = useTwilioAccountsService();
  const queryClient = useQueryClient();

  return useMutation<TwilioAccountModel, AxiosError, CreateTwilioAccountParams>({
    mutationFn: (params: CreateTwilioAccountParams) =>
      twilioAccountsService.createTwilioAccount(params),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [twilioAccountsListQueryKey] }),
  });
};
